/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Link
} from '@one-thd/sui-atomic-components';
import { Duplicate, Confirmed, Error } from '@one-thd/sui-icons';
import { COPY_SUCCESS, COPY_ERROR } from '../../AddToConstants';
import { formatProductsforCopy } from '../../AddToHelpers';

export const CopyExceptions = ({ productExceptions }) => {
  const [showCopyStatus, setShowCopyStatus] = useState({ showStatus: false, status: '' });

  const copyableText = formatProductsforCopy(productExceptions);

  const handleCopyButtonClick = (event) => {
    event.preventDefault();

    navigator.clipboard.writeText(copyableText)
      .then(() => {
        setShowCopyStatus({ showStatus: true, status: 'success' });
        setTimeout(() => {
          setShowCopyStatus({ showStatus: false, status: '' });
        }, 5000);
      })
      .catch((_error) => {
        setShowCopyStatus({ showStatus: true, status: 'error' });
        setTimeout(() => {
          setShowCopyStatus({ showStatus: false, status: '' });
        }, 5000);
      });
  };

  if (!showCopyStatus.showStatus) {
    return (
      <>
        <div className="sui-pt-2">
          <Duplicate size="small" />
        </div>
        <Link component="button" onClick={handleCopyButtonClick}>
          Copy item details to clipboard
        </Link>
      </>
    );
  }
  return (
    <>
      <div className="sui-pt-2">
        {showCopyStatus.status === 'success'
          ? <Confirmed size="small" color="success" />
          : <Error size="small" color="danger" />}
      </div>
      <div className="sui-pt-1">
        {showCopyStatus.status === 'success'
          ? <Typography color="success">{COPY_SUCCESS}</Typography>
          : <Typography color="danger">{COPY_ERROR}</Typography>}
      </div>
    </>
  );

};

CopyExceptions.displayName = 'CopyExceptions';

CopyExceptions.propTypes = {
  productExceptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};